import { generatePath, useParams } from 'react-router-dom'
import { faGear } from '@fortawesome/pro-light-svg-icons/faGear'
import { faTrash } from '@fortawesome/pro-light-svg-icons/faTrash'
import { paths } from 'src/router/paths'
import { useCustomEvent } from 'src/hook/useCustomEvent'
import i18n from 'src/i18n'
import { DropdownActions } from '../dropdownActions'
import { MenuItemImage } from '../menuItemImage'
import { CommunityBadge } from '../communityBadge'
import { CommunityListMenuEventNames } from '../../communityListMenu.types'
import { useCommunityPermissions } from '../../hooks'
import { MenuItemProps, PathParams } from './menuItem.types'
import { Text, Wrapper } from './menuItem.styles'

const MenuItem = ({ group, community }: MenuItemProps) => {
  const params = useParams<PathParams>()
  const { emitEvent } = useCustomEvent()
  const { canSetUpCommunity, canDeleteCommunity } = useCommunityPermissions(community)

  const { lang, idCommunity } = params
  const communityIdParam = idCommunity || params['*']
  const isActive = community.id === Number(communityIdParam)
  const url = generatePath(paths.COMMUNITY_PATH, {
    lang,
    membership: group.slug,
    idCommunity: String(community.id)
  })

  const shouldRenderActions = canSetUpCommunity || canDeleteCommunity
  const communityActions = [
    {
      label: i18n.t('sidebar_menu.community.actions.settings'),
      icon: faGear,
      visible: canSetUpCommunity,
      callback: () =>
        emitEvent(CommunityListMenuEventNames.SET_UP_COMMUNITY, {
          communityId: community.id
        })
    },
    {
      label: i18n.t('sidebar_menu.community.actions.delete'),
      icon: faTrash,
      visible: canDeleteCommunity,
      callback: () =>
        emitEvent(CommunityListMenuEventNames.DELETE_COMMUNITY, {
          community
        })
    }
  ]

  return (
    <Wrapper
      to={url}
      className="_d-flex _align-items-center _text-decoration-none _rounded _pr-4"
      $active={isActive}
    >
      <MenuItemImage
        community={community}
        hasNotification={community.hasUnseenNewsOrCommentReplies}
      />

      <div className="_d-flex _align-items-center _justify-content-between _flex-1">
        <Text
          className="_d-flex _align-items-center _justify-content-between _flex-1 _font-14 _text-gray-900"
          $hasNotification={community.hasUnseenNewsOrCommentReplies}
          $isActive={isActive}
        >
          <span className="_mr-4">{community.name}</span>
        </Text>

        <CommunityBadge communityType={community.type} className="_ml-1" />

        {shouldRenderActions && <DropdownActions items={communityActions} />}
      </div>
    </Wrapper>
  )
}

export default MenuItem
